import { FabricImage } from '@/fabric';

export class ImageService {
  static async createFabricImageFromUrl (urlOrBase64String: string) {
    return FabricImage.fromURL(urlOrBase64String);
  }
}
